export default __webpack_public_path__ + "static/media/star-solid.2df4aaff.svg";